import React, { useEffect, useRef, useState } from 'react';

import emptyIcon from '#/assets/icons/empty-box.svg';
import styles from './styles.module.css';

import { useTranslation } from "react-i18next";

const NotFound = () => {
  const [showImage, setShowImage] = useState(false);
  const wrapper = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const { offsetWidth, offsetHeight } = wrapper.current;
    if (offsetHeight > 150 && offsetWidth > 250) setShowImage(true);
    else setShowImage(false);
  });

  return (
    <span className={styles.wrapper} ref={wrapper}>
      {showImage && (
        <img
          src={emptyIcon}
          alt={t('EMPTY_BOX')}
          className={styles.emptyIcon}
          draggable={false}
        />
      )}
      <h3 className={styles.title}>{t('NO_RECORDS')}</h3>
      <p className={styles.message}>
        {t('FILTER_USAGE_TIP')}
      </p>
    </span>
  );
};

export default NotFound;
